import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ModelService } from '../proxy/general/controllers/model.service';

FieldBuilder.setNamespace('General');

export const NOZZLE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('modelId', 'Entity.Model', ModelService)
    .displayFromNested('model.name')
    .sortBy('model.name')
    .build(),
  FieldBuilder
    .number('flow', 'Entity.Nozzle.Flow')
    .decimal(2,5)
    .build(),
  FieldBuilder
    .text('color', 'Entity.Nozzle.Color')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .number('pressure', 'Entity.Nozzle.Pressure')
    .required()
    .decimal(2,5)
    .build(),
];

export const NOZZLE_CONFIG = {
  entityName: 'Nozzle',
  localizationKey: 'General::Entity.Nozzle',
  fields: NOZZLE_FIELDS,
  permission: 'Silviculture.Nozzles',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Silviculture + MENU_NAME_SUFFIX,
  menuSubcategory: undefined,
};
